import RadioButton from '@/components/common/RadioButton/RadioButton';
import { IValidationResults } from '@/data/models/validation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroupProps } from './types';
import ReadOnlyField from '../../../common/ReadOnlyField/ReadOnlyField';

type Props = FormGroupProps & {
  albumErrors: IValidationResults[];
  onChangeTargetAccount: boolean;
  onClickTargetAccount: boolean;
  yesOption: string;
  noOption: string;
  setOnClickTargetAccount: (value: React.SetStateAction<boolean>) => void;
  setOnChangeTargetAccount: (value: React.SetStateAction<boolean>) => void;
  handleAccountExclusiveChange: (e: any) => void;
  handleAlbumMetaData: (field: string, value: string | null) => void;
};

export default function AccountExclusiveReleaseFormGroup({
  album,
  readonly,
  disabled,
  albumErrors,
  onChangeTargetAccount,
  onClickTargetAccount,
  yesOption,
  noOption,
  setOnClickTargetAccount,
  setOnChangeTargetAccount,
  handleAccountExclusiveChange,
  handleAlbumMetaData,
  findErrorMessage,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label
            htmlFor="exclusiveReleaseAccount"
            className="col-sm-3 form-label"
          >
            {t('product.editProduct.accountExclusiveRelease')}
          </label>
          <div className="col-sm-6 pair-input-container padding-left-0">
            <div className="col-sm-12 padding-right-0">
              <div className="pair-input">
                <div className="fixed-left">
                  <RadioButton
                    options={[yesOption, noOption]}
                    selectedOption={
                      album.albumMetaData?.exclusiveReleaseAccount
                        ? yesOption
                        : noOption
                    }
                    id="exclusiveReleaseAccount"
                    name="exclusiveReleaseAccount"
                    className="leftPadding"
                    labelClass="leftPadding"
                    onOptionChange={handleAccountExclusiveChange}
                    disabled={disabled}
                  />
                </div>
                {album.albumMetaData?.exclusiveReleaseAccount && (
                  <div className="right-fill">
                    <input
                      className={
                        albumErrors.find(
                          (va) => va.fieldName === 'ExclusiveReleaseAccountName'
                        ) && !onChangeTargetAccount
                          ? 'form-control invalid-input'
                          : 'form-control'
                      }
                      type="text"
                      defaultValue={
                        album.albumMetaData?.exclusiveReleaseAccountName ?? ''
                      }
                      onClick={() => setOnClickTargetAccount(true)}
                      onChange={(e) => {
                        setOnChangeTargetAccount(true);
                        handleAlbumMetaData(
                          'exclusiveReleaseAccountName',
                          e.target.value
                        );
                      }}
                      onBlur={() => setOnClickTargetAccount(false)}
                      disabled={disabled}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          {albumErrors.find(
            (va) => va.fieldName === 'ExclusiveReleaseAccountName'
          ) &&
          !onChangeTargetAccount &&
          onClickTargetAccount ? (
            <div className="col-sm-2 popUp-container">
              {findErrorMessage('ExclusiveReleaseAccountName')}
            </div>
          ) : null}
        </div>
      ) : (
        <ReadOnlyField
          id="title"
          labelTitle={t('product.editProduct.accountExclusiveRelease')}
          value={[
            album.albumMetaData?.exclusiveReleaseAccount
              ? t('product.yes')
              : t('product.no'),
            album.albumMetaData?.exclusiveReleaseAccountName,
          ]}
          customValuesSeparator={
            album.albumMetaData?.exclusiveReleaseAccountName ? ' - ' : ''
          }
        ></ReadOnlyField>
      )}
    </>
  );
}
